export default __webpack_public_path__ + "static/media/refsocial-b.5b5fef0d.svg";